import React from "react";
import { Package, Info, Euro, CreditCard } from "lucide-react";

export function PricingGuidance() {
  return (
    <div className="space-y-6">
      {/* Commission Information */}
      <div className="bg-green-50 p-4 rounded-lg border border-green-200">
        <h4 className="font-semibold text-green-800 mb-3 flex items-center gap-2">
          <CreditCard className="w-4 h-4" />
          Commission Structure
        </h4>
        <div className="grid md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-green-700 mb-2">
              <strong>You Keep: 80%</strong> of your consultation fee
            </p>
            <p className="text-green-600 text-xs">
              Example: If you charge €200, you receive €160
            </p>
          </div>
          <div>
            <p className="text-green-700 mb-2">
              <strong>Platform Fee: 20%</strong> covers our services
            </p>
            <p className="text-green-600 text-xs">
              Client matching, payments, support, and platform maintenance
            </p>
          </div>
        </div>
      </div>

      {/* Package Selection */}
      <div>
        <h4 className="font-semibold text-blue-800 mb-3 flex items-center gap-2">
          <Package className="w-4 h-4" />
          Set Your Own Pricing for Each Package
        </h4>
        <p className="text-sm text-gray-600 mb-4">
          Choose which service packages you'd like to offer and set your own prices for each. You have full control over your pricing strategy.
        </p>
      </div>

      {/* Pricing Guidelines */}
      <div>
        <h4 className="font-semibold text-blue-800 mb-3 flex items-center gap-2">
          <Euro className="w-4 h-4" />
          Suggested Price Ranges
        </h4>
        <div className="bg-white rounded-lg border border-blue-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-blue-100">
              <tr>
                <th className="text-left p-3 font-medium text-blue-900">Package Type</th>
                <th className="text-left p-3 font-medium text-blue-900">Suggested Range (€)</th>
                <th className="text-left p-3 font-medium text-blue-900">What Families Expect</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-blue-100">
                <td className="p-3 text-gray-700 font-medium">Introductory Consultation</td>
                <td className="p-3 text-gray-700">€60 – €90</td>
                <td className="p-3 text-gray-700 text-sm">Quick advice and initial assessment</td>
              </tr>
              <tr className="border-b border-blue-100">
                <td className="p-3 text-gray-700 font-medium">Standard Support Package</td>
                <td className="p-3 text-gray-700">€150 – €250</td>
                <td className="p-3 text-gray-700 text-sm">Comprehensive guidance and documentation review</td>
              </tr>
              <tr>
                <td className="p-3 text-gray-700 font-medium">Premium Case Management</td>
                <td className="p-3 text-gray-700">€300 – €500+</td>
                <td className="p-3 text-gray-700 text-sm">Full case management and ongoing support</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Notes for Experts */}
      <div className="bg-white p-4 rounded-lg border border-blue-200">
        <h4 className="font-semibold text-blue-800 mb-2 flex items-center gap-2">
          <Info className="w-4 h-4" />
          Pricing Tips for Success
        </h4>
        <ul className="text-sm text-gray-600 space-y-2 list-disc ml-4">
          <li><strong>You set your own rates</strong> — these are only guidelines to help you understand market expectations</li>
          <li><strong>Consider your expertise</strong> — specialists with certifications can often charge higher rates</li>
          <li><strong>Factor in your time</strong> — include preparation, consultation, and follow-up time in your pricing</li>
          <li><strong>Be transparent</strong> — families appreciate knowing exactly what they're paying for</li>
          <li><strong>Start competitive</strong> — you can always adjust your rates as you build your reputation</li>
          <li><strong>Remember the commission</strong> — you'll receive 80% of your listed price, so factor this into your pricing strategy</li>
        </ul>
      </div>
    </div>
  );
}
